import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { TimeoutPageRoutingModule } from './timeout-routing.module';

import { TimeoutPage } from './timeout.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    TimeoutPageRoutingModule,
    TranslateModule
  ],
  declarations: [TimeoutPage]
})
export class TimeoutPageModule {}
